<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import service1 from '@/assets/home/service1.svg';
import service2 from '@/assets/home/service2.svg';
import service3 from '@/assets/home/service3.svg';
import service4 from '@/assets/home/service4.svg';
import service5 from '@/assets/home/service5.svg';
import service6 from '@/assets/home/service6.svg';

const { t, locale } = useI18n();

const services = [
  {
    title: t('home.services.content1.title'),
    description: t('home.services.content1.desc'),
    image: service1,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content1.tag1'),
        t('home.services.content1.tag2'),
        t('home.services.content1.tag3'),
      ]
      : [],
  },
  {
    title: t('home.services.content2.title'),
    description: t('home.services.content2.desc'),
    image: service2,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content2.tag1'),
        t('home.services.content2.tag2'),
        t('home.services.content2.tag3'),
      ]
      : [],
  },
  {
    title: t('home.services.content3.title'),
    description: t('home.services.content3.desc'),
    image: service3,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content3.tag1'),
        t('home.services.content3.tag2'),
        t('home.services.content3.tag3'),
      ]
      : [],
  },
  {
    title: t('home.services.content4.title'),
    description: t('home.services.content4.desc'),
    image: service4,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content4.tag1'),
        t('home.services.content4.tag2'),
        t('home.services.content4.tag3'),
      ]
      : [],
  },
  {
    title: t('home.services.content5.title'),
    description: t('home.services.content5.desc'),
    image: service5,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content5.tag1'),
        t('home.services.content5.tag2'),
        t('home.services.content5.tag3'),
      ]
      : [],
  },
  {
    title: t('home.services.content6.title'),
    description: t('home.services.content6.desc'),
    image: service6,
    tags: locale.value === 'zh-CN'
      ? [
        t('home.services.content6.tag1'),
        t('home.services.content6.tag2'),
        t('home.services.content6.tag3'),
      ]
      : [],
  },
];
</script>

<template>
  <section class="page-home-services bg-#F9FCFF py-100 <md:py-40">
    <div class="mx-auto max-w-1200 <sm:px-16 <xl:px-24">
      <h2 class="my-0 text-center text-40 text-#292D33 font-600 leading-60 <md:text-28">
        {{ $t('home.services.title') }}
      </h2>

      <p class="mx-auto mb-0 mt-30 w-720 text-center text-20 text-#9497A1 font-400 leading-33 <md:w-full <md:text-14 <md:leading-24">
        {{ $t('home.services.desc') }}
      </p>

      <div class="mt-56 flex flex-wrap gap-x-38 gap-y-16 <md:mt-32 <md:gap-x-0">
        <div
          v-for="(service, index) in services"
          :key="index"
          class="h-148 w-580 flex gap-x-24 rounded-8 bg-white px-40 pb-0 pt-24 <md:h-auto <md:w-full <md:px-16 <md:pb-24"
        >
          <div class="flex-shrink-0">
            <img :src="service.image" alt="" class="size-64">
          </div>

          <div class="flex-grow overflow-hidden">
            <h3 class="m-0 text-20 text-#25324B font-600 leading-1.2em">
              {{ service.title }}
            </h3>

            <p
              class="mb-0 mt-8 text-16 text-#515B6F font-400 leading-1.6em"
              :class="{ 'truncate': service?.tags.length }"
              :title="service.description"
            >
              {{ service.description }}
            </p>

            <div class="mt-8 flex-y-center gap-x-16 <md:flex-col <md:gap-x-0 <md:gap-y-8" v-if="service?.tags.length">
              <div
                v-for="(tag, tagIndex) in service.tags"
                :key="tagIndex"
                class="h-34 flex-y-center border-1 border-#1281FF rounded-full border-solid px-10 text-14 text-#1281FF font-500 <md:w-full <md:justify-center"
              >
                {{ tag }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-60 text-center <md:mt-32">
        <a href="https://service.openatom.cn/" target="_blank">
          <button class="h-54 w-171 cursor-pointer border-0 rounded-6 bg-[#1281ff] text-16 text-white font-semibold leading-24 <md:w-full">{{ $t('home.services.button') }}</button>
        </a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
